import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    users: [],
    stats: null,
    loading: false,
    error: null,
    pagination: {
        page: 1,
        limit: 10,
        total: 0,
    },
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUsers: (state, action) => {
            state.users = action.payload;
        },
        setStats: (state, action) => {
            state.stats = action.payload;
        },
        setPagination: (state, action) => {
            state.pagination = { ...state.pagination, ...action.payload };
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        updateUserStatus: (state, action) => {
            const { id, status } = action.payload;
            const user = state.users.find((u) => u.id === id);
            if (user) {
                user.status = status;
            }
        },
        clearError: (state) => {
            state.error = null;
        },
    },
});

export const { setUsers, setStats, setPagination, setLoading, setError, updateUserStatus, clearError } =
    userSlice.actions;

export default userSlice.reducer;
